import React, { Profiler } from "react";
import Profile from "../Images/profile.jpg";
import pdf from "../Resume/Rutvik-Patel-Resume.pdf";
import { Link } from "react-router-dom";
import Typical from "react-typical";
import "./About.css";

const About = () => {
  const onResumeClick = () => {
    window.open(pdf);
  };

  return (
    <section className="about" id="about">
      <div className="max-width">
        <h2 className="title">About me</h2>
        <div className="about-content">
          <div className="column left">
            <img src={Profile} alt="A" />
          </div>
          <div className="column right">
            <div className="text">
              I'm Rutvik and I'm a{" "}
              <span className="typing-2">
                <Typical
                  steps={[
                    "Learner",
                    1000,
                    "upcoming Developer",
                    1000,
                    "Enthusiastic Person",
                    1000,
                    "Swimmer",
                    1000,
                    "Team player",
                    1000,
                  ]}
                  loop={Infinity}
                  wrapper="p"
                />
              </span>
            </div>
            <p>
              I have pursued Computer Programming Diploma at Algonquin
              College where I gained knowledge in the domains of Database,
              Software Development, Algorithms, and Web Programming. I am
              proficient in developing applications.The interest in coding has
              increased day by day after exploring my coding skills. I love to
              analyze problems and find out the best method to solve the problem
              in an optimized way. I am a person who loves to help others,
              hardest worker in the room and always open to learn new tools and
              technology.
            </p>
            <p className="Skills">Skills: HTML, CSS, JavaScript, JAVA, SQL, React Js, SCSS and thirst to learn more.</p>

            <button
              type="button"
              className="attribute"
              onClick={(e) => {
                e.preventDefault();
                window.open(pdf);
              }}
            >
              {" "}
              Download Resume
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
